import { render, staticRenderFns } from "./ChildrenRiderWidget.vue?vue&type=template&id=6dc9c530&scoped=true"
import script from "./ChildrenRiderWidget.vue?vue&type=script&lang=js"
export * from "./ChildrenRiderWidget.vue?vue&type=script&lang=js"
import style0 from "./ChildrenRiderWidget.vue?vue&type=style&index=0&id=6dc9c530&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc9c530",
  null
  
)

export default component.exports